<template>
  <Dashboard />
</template>

<style lang="scss">
@import "./main.scss";
</style>
<script>
import Dashboard from "@/components/Dashboard";

export default {
  components: { Dashboard },
};
</script>
